var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"average-line",style:(`
    bottom: calc(${_vm.max_value !== 0? `${(_vm.value / _vm.max_value)} * (100% - 25px)`:'0px'});
    ${_vm.width?`width: ${_vm.width};`:''}
  `)},[(_vm.value !== 0)?_c('div',{staticClass:"average-line-value"},[_vm._v(_vm._s(_vm.value))]):_vm._e(),_c('div',{staticClass:"average-line-marker"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }